import { useQuery } from "react-query";

import { TemplateSessionListQueryID } from "@hooks/hooksConstants";
import { getTemplateSessions } from "@services/session.service";

const useTemplateSessions = () => useQuery([TemplateSessionListQueryID], () => getTemplateSessions());

export default useTemplateSessions ;
